import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, "خلال الفترة من", -1)
const _hoisted_2 = { class: "p-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, "الي", -1)
const _hoisted_4 = { class: "p-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_time = _resolveComponent("n-time")!

  return ($props.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass($props.className)
      }, [
        _hoisted_1,
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_n_time, { time: $setup.dateFrom }, null, 8, ["time"])
        ]),
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_n_time, { time: $setup.dateTo }, null, 8, ["time"])
        ])
      ], 2))
    : _createCommentVNode("", true)
}